import { useState, useEffect } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("sf_consent")) setShow(true);
  }, []);

  const choose = (val) => {
    localStorage.setItem("sf_consent", val);
    setShow(false);
    if (val === "all") {
      axios.post(`${API}/analytics/pageview`, { path: window.location.pathname }).catch(() => {});
    }
  };

  return (
    <AnimatePresence>
      {show && (
        <div className="fixed bottom-4 inset-x-0 z-[70] flex justify-center pointer-events-none px-4">
          <motion.div
            data-testid="cookie-banner"
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 60 }}
            transition={{ type: "spring", stiffness: 240, damping: 22 }}
            className="pointer-events-auto w-[min(94vw,600px)] rounded-2xl bg-[#0b0f19] text-white p-5 sm:p-6 shadow-2xl border border-white/10"
          >
            <div className="flex items-start gap-3.5">
              <span className="w-9 h-9 shrink-0 rounded-xl bg-[#16a34a]/20 flex items-center justify-center">
                <Cookie className="w-[18px] h-[18px] text-[#16a34a]" />
              </span>
              <div className="flex-1">
                <p className="font-display font-bold text-base leading-snug">Vi värnar om din integritet</p>
                <p className="mt-1.5 text-xs sm:text-sm text-slate-400 leading-relaxed">
                  Inga spårningscookies – bara nödvändig lagring för att sidan ska fungera. Får vi även räkna
                  anonyma sidvisningar (utan IP-adress eller cookies)?{" "}
                  <a href="/cookiepolicy" data-testid="cookie-banner-policy-link" className="underline text-slate-300 hover:text-[#16a34a] transition-colors">
                    Läs mer
                  </a>
                </p>
                <div className="mt-4 flex flex-wrap gap-2.5">
                  <button
                    data-testid="cookie-accept-all"
                    onClick={() => choose("all")}
                    className="bg-[#16a34a] hover:bg-[#15803d] text-white text-sm font-bold px-5 py-2.5 rounded-full transition-colors duration-300"
                  >
                    Godkänn statistik
                  </button>
                  <button
                    data-testid="cookie-accept-necessary"
                    onClick={() => choose("necessary")}
                    className="bg-white/10 hover:bg-white/20 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors duration-300"
                  >
                    Endast nödvändiga
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
